var _circle, _circle2, _circle3, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 434,
    viewBox: "0 0 218 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5312,
    cy: 250.01,
    r: 10,
    fill: "#F49F0A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 34.0312,
    cy: 280.51,
    r: 7.5,
    fill: "#F49F0A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9902,
    cy: 307,
    r: 5,
    fill: "#F49F0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 317C170.228 317 215 272.228 215 217C215 161.772 170.228 117 115 117",
    stroke: "#00A6A6",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52051 217.05C3.52051 161.822 48.292 117.05 103.521 117.05",
    stroke: "#00A6A6",
    strokeWidth: 3,
    strokeDasharray: "15 15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.e29f1b2d51b50c0b67b7e55a26ad89b8.svg";
export { ForwardRef as ReactComponent };